import React from 'react';
import './App.css';

import BasicSheet from './components/BasicSheet'
import Header from './components/Header'
import Footer from './components/Footer'

import ListView from './components/ListView'

import { Container } from 'reactstrap'

import { BrowserRouter as Router, Route } from 'react-router-dom'

function App() {
  return (
    <>
      <Header />
      <Container className="overflow-auto" fluid={true}>
        <Router>
          <Route exact path="/">
              <BasicSheet />
          </Route>
          <Route exact path="/itemlist">
            <ListView />
          </Route>
        </Router>
      </Container>
      <Footer />
    </>
  );
}

export default App;
